/* eslint class-methods-use-this: "off"  */

import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import _ from "underscore";
import Input from "@exovera/input";
import vars from "@exovera/narrative-tracker-variables";
import RoundSpinner from "genericComponents/RoundSpinner";

import { createOriginalPassword, openForgotPasswordView, updateChangePasswordNew, updateChangePasswordOld } from "actions/login.js";

import { isPasswordValid } from "lib/helpers/loginHelpers.js";

class ChangePassword extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			focusOldPassword: true,
			focusNewPassword: false,
			newPasswordValid: false,
			oldPasswordError: false,
		};
		this.validateForm = this.validateForm.bind(this);
		this.validateNewPassword = this.validateNewPassword.bind(this);
	}

	validateForm() {
		const { props, state } = this;
		if (
			// everything is valid, dispatch event
			!props.validationInProgress &&
			props.loginInputChangePasswordOld &&
			state.newPasswordValid
		) {
			this.setState({ oldPasswordError: false });
			props.dispatch(createOriginalPassword(props.loginInputChangePasswordOld, props.loginInputChangePasswordNew));
		} else if (
			// nothint is valid, show all errors
			!props.validationInProgress &&
			!props.loginInputChangePasswordOld &&
			!state.newPasswordValid
		) {
			this.setState({ oldPasswordError: true, focusOldPassword: true });
		} else if (!props.validationInProgress && !state.newPasswordValid) {
			// New password invalid, show that error - shouldn't ever fire; password already checked
			this.setState({ focusNewPassword: true });
		} else if (!props.validationInProgress && !props.loginInputChangePasswordOld) {
			// Old password invalid, show that error
			this.setState({ oldPasswordError: true, focusOldPassword: true });
		}
	}
	// check if the password is valid before updating the input
	validateNewPassword(password) {
		const { props } = this;
		const passwordValid = isPasswordValid(password);

		this.setState({ newPasswordValid: passwordValid });
		props.dispatch(updateChangePasswordNew(password));
	}

	render() {
		const { props, state } = this;
		// console.log("ChangePassword", props, state);
		const loginClass = classnames("login", { error: props.loginError });
		const oldPasswordErrorClass = classnames("login__error", { visible: state.oldPasswordError });
		const submitClass = classnames("login__submit", {
			disabled: !state.newPasswordValid || !props.loginInputChangePasswordOld,
		});
		const buttonBoxClass = classnames("login__submit-box", { spinner: props.validationInProgress });
		const checkmarkNewClass = classnames("login__password-valid-checkmark", {
			visible: state.newPasswordValid,
		});

		return (
			<div className={loginClass}>
				<div className="login__box">
					<p className="login__top-error">{props.loginErrorText}</p>

					<h1 className="login__header">Please Change Your Password</h1>

					{!props.userJustLoggedIn && (
						<div className="login__input-box">
							<label htmlFor="login-email" className="login__input-label">
								Current Password
							</label>
							<div className="login__forgot-password" onClick={() => props.dispatch(openForgotPasswordView())}>
								Forgot password?
							</div>
							<Input
								acceptBtnFunction={this.validateForm}
								localAccept
								focus={state.focusOldPassword} // can set focus by passing a prop
								label={false}
								id="login-email"
								// note: PropTypes.func, // appears below input. Expects a React component
								onChange={(value) => props.dispatch(updateChangePasswordOld(value))}
								placeholder=""
								theme={props.darkUI ? "dark" : "white"}
								type="password"
								value={props.loginInputChangePasswordOld}
							/>
							<p className={oldPasswordErrorClass}>Please enter your current password.</p>
						</div>
					)}

					<div className="login__input-box">
						<label htmlFor="login-email" className="login__input-label">
							New Password
						</label>
						<Input
							acceptBtnFunction={this.validateForm}
							localAccept
							focus={state.focusNewPassword} // can set focus by passing a prop
							label={false}
							// note: PropTypes.func, // appears below input. Expects a React component
							onChange={(text) => this.validateNewPassword(text)}
							placeholder=""
							theme={props.darkUI ? "dark" : "white"}
							type="password"
							value={props.loginInputChangePasswordNew}
						/>
						<div className={checkmarkNewClass} />
						<p className="login__instructions">
							Password must be at least eight characters, including one uppercase character, one lowercase character, and a number.
						</p>
					</div>

					<div className={buttonBoxClass}>
						<div className="login__spinner">
							<RoundSpinner scale={0.6} color={vars.cerulean_2} />
						</div>

						<button type="submit" className={submitClass} aria-disabled={!state.passwordsMatch} onClick={this.validateForm}>
							<span className="login__submit--text">Save Changes</span>
						</button>
					</div>
				</div>
			</div>
		);
	}
}

ChangePassword.propTypes = {
	darkUI: PropTypes.bool.isRequired,
	dispatch: PropTypes.func.isRequired,
	// controls this modal and Login views
	loginError: PropTypes.bool.isRequired,
	loginErrorText: PropTypes.string.isRequired,

	loginInputChangePasswordNew: PropTypes.string.isRequired,
	loginInputChangePasswordOld: PropTypes.string.isRequired,
	userJustLoggedIn: PropTypes.bool.isRequired,
	validationInProgress: PropTypes.bool.isRequired,
};

export default ChangePassword;
